import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  empty: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: theme.spacing(4),
    gap: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
}))

export default useStyles
